import * as React from 'react'
import { styled } from 'styled-components'
import { Button } from 'react-bootstrap'
import * as domain from '@packages/domain'
import { RR, pipe, TE, t } from '@packages/prelude'
import { PurchaseForm } from './PurchaseForm'
import * as pdf from '~/api/pdf'
import { downloadBlob, generatePDFFilename } from '~/commons/download'
import { generateConfigurationData } from '~/commons/configurationData'

const Container = styled.div`
  scroll-margin-top: 3rem;
  margin-top: 3rem;
  margin-bottom: 3rem;

  padding-top: 3rem;

  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`

const Content = styled.div`
  width: 100%;

  @media screen and (min-width: 768px) {
    width: 50%;
  }
`

const Highlight = styled.p`
  padding: 1em;

  color: #fff;
  background-color: #ce8938;
`

interface PurchaseProps {
  id: string
  selectedOptions: RR.ReadonlyRecord<string, ReadonlyArray<domain.Option.Type>>
  configuration: domain.Configurator.Type
  productId: number
  categoryName: t.NonEmptyString
  deliveryNotice: t.NonEmptyString
  price: number
}

export const Purchase = React.forwardRef<HTMLDivElement, PurchaseProps>(
  ({ id, selectedOptions, configuration, productId, categoryName, deliveryNotice, price }, ref) => {
    const [show, setShow] = React.useState(false)
    const [pdfLoading, setPdfLoading] = React.useState(false)

    const handlePDFDownload = () => {
      setPdfLoading(true)

      pipe(
        generateConfigurationData(selectedOptions, price, configuration.id, productId),
        pdf.generatePDF,
        TE.match(
          error => {
            console.error('PDF generation failed:', error)
            alert('PDF konnte nicht generiert werden. Bitte versuchen Sie es später erneut.')
            setPdfLoading(false)
          },
          async blob => {
            const filename = generatePDFFilename(configuration.id)
            await downloadBlob(blob, filename)
            setPdfLoading(false)
          }
        )
      )()
    }

    return (
      <Container ref={ref} id={`${id}`}>
        <div className="w-100">
          <Content>
            <h2>
              Sind Sie zufrieden?
              <br />
              {`${categoryName} komplett?`}
            </h2>
            <p>
              <strong>Herzlichen Glückwunsch. Was möchten Sie tun?</strong>
            </p>
            <Highlight>
              <strong>{deliveryNotice}</strong>
            </Highlight>
          </Content>
        </div>

        <Button variant="secondary" className="my-5" onClick={() => setShow(true)}>
          {categoryName} jetzt kaufen
        </Button>

        <Button variant="link" onClick={handlePDFDownload} disabled={pdfLoading}>
          <span>{pdfLoading ? 'PDF wird generiert...' : 'PDF downloaden'}</span>
          <i className="rt-arrow-right badge-secondary ms-3" />
        </Button>

        <PurchaseForm
          show={show}
          onHide={() => setShow(false)}
          selectedOptions={selectedOptions}
          configuration={configuration}
          productId={productId}
          price={price}
        />
      </Container>
    )
  }
)

Purchase.displayName = 'Purchase'
